// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","overflow-hidden":"overflow-hidden-31ez1jwuh29h8x2yktu97kb81bs28k5u1gf55zjnrwy145dmxemz6sc1pfbfs7je3njkbdryh93s5tq8ne9cbv93h898njfembr1dfx","loading":"loading-4wg3r4jgw2xnkbnw59syf1v9j6mpt6zc7z1nxftqqenf3a37zjwatdypwvd2czg7gevxnuykm45betmmbm3z4vwmqzg2b61ky5tnsdc","pulse":"pulse-3j6m4g3vvmugsuz3np98e79dy4e6pe6tbpmpnyhjfe8mrdc9m2w1h2n6rtrx91vfj4v7pjqxs12xj9xdpq65t6tp7quveupteebud9z"};


//////////////////
// WEBPACK FOOTER
// ./src/index.module.scss
// module id = 715
// module chunks = 0